import { MARQUEE_ITEMS } from "../data/content";

export const Marquee = () => {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-cyan-500/10 bg-dg-navy2/70 py-6">
      <div className="flex w-max animate-marquee items-center">
        {items.map((t, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display whitespace-nowrap px-8 text-2xl sm:text-3xl font-bold tracking-tight text-white/85">
              {t}
            </span>
            <span className="text-dg-cyan text-lg">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
